<!--  -->
<template>
    <div class='card_wrapper box box_v'>
        <div class="box_f1 box" style="margin-top:20px">
            <div class="tr_item box">
                <img :src="dy_pic"/>
                <div class="box_f1 box box_v">
                    <div class="title">党员</div>
                    <div class="number" v-if="partyMemberCount">{{partyMemberCount}}人</div>
                </div>
            </div>
            <div class="tr_item box">
                <img :src="dy_dzb"/>
                <div class="box_f1 box box_v">
                    <div class="title">党支部</div>
                    <div class="number" v-if="partyZoneCount">{{partyZoneCount}}个</div>
                </div>
            </div>
        </div>
        <div class="box_f1 box">
            <div class="tr_item box">
                <img :src="dy_wg"/>
                <div class="box_f1 box box_v">
                    <div class="title">网格</div>
                    <div class="number" v-if="gridCount">{{gridCount}}个</div>
                </div>
            </div>
            <div class="tr_item box">
                <img :src="dy_zyz"/>
                <div class="box_f1 box box_v">
                    <div class="title">志愿者队伍</div>
                    <div class="number" v-if="volunteerOrgCount">{{volunteerOrgCount}}个</div>
                </div>
            </div>
        </div>
        <div class="box_f1 box">
            <div class="tr_item box">
                <img :src="dy_wy"/>
                <div class="box_f1 box box_v">
                    <div class="title">物委会</div>
                    <div class="number" v-if="propertyCommitteeCount">{{propertyCommitteeCount}}个</div>
                </div>
            </div>
            <div class="tr_item box">
                <img :src="dy_yz"/>
                <div class="box_f1 box box_v">
                    <div class="title">业主委员会</div>
                    <div class="number" v-if="ownerCommitteeCount">{{ownerCommitteeCount}}个</div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            dy_pic: require('../../../assets/images/monitorctxf/dy.png'),
            dy_dzb: require('../../../assets/images/monitorctxf/dzb.png'),
            dy_yz: require('../../../assets/images/monitorctxf/yz.png'),
            dy_wg: require('../../../assets/images/monitorctxf/wg.png'),
            dy_zyz: require('../../../assets/images/monitorctxf/zyz.png'),
            dy_wy: require('../../../assets/images/monitorctxf/wy.png'),
            gridCount: null,
            ownerCommitteeCount: null,
            partyMemberCount: null,
            partyZoneCount: null,
            propertyCommitteeCount: null,
            volunteerOrgCount: null,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            this.$get(this.urlobj.xf_overview).then(res=>{
                this.gridCount=res.newPrimaryKeys.gridCount.toLocaleString()
                this.ownerCommitteeCount=res.newPrimaryKeys.ownerCommitteeCount.toLocaleString()
                this.partyMemberCount=res.newPrimaryKeys.partyMemberCount.toLocaleString()
                this.partyZoneCount=res.newPrimaryKeys.partyZoneCount.toLocaleString()
                this.propertyCommitteeCount=res.newPrimaryKeys.propertyCommitteeCount.toLocaleString()
                this.volunteerOrgCount=res.newPrimaryKeys.volunteerOrgCount.toLocaleString()
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.card_wrapper{
    width: 100%;
    height:100%;
    background-image: url('../../../assets/images/monitorctxf/lefttop.png');
    background-size: 100% 100%;
    .tr{
        height:33%;
    }
    .tr_item{
        margin:0 auto;
        align-items: center;
        width:40%
    }
    .title{
        font-size: 14px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 16px;
        margin-left:5px
    }
    .number{
        margin-top:5px;
        font-size: 20px;
        font-weight: bold;
        font-style: italic;
        color: #B3DDFF;

        background: linear-gradient(0deg, #F5A418 0%, #FFDE00 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    img{
        width:54px;
        height:54px;
        margin:0 auto;
        margin-right:2px
    }
}
</style>